import StyledButton from '../../components/Button/Button';
import {
    StyledSection,
    StyledHeading,
    StyledHighlight,
    TextContainer,
    StyledContainer,
} from './styles';

import { buttonVariant } from '../../types/buttonTypes';

export interface CTASectionProps {
    title?: string;
    subtitle?: string;
    buttons?: {
        title: string;
        href: string;
        variant: buttonVariant;
    }[];
    padding?: string;
}

const CTASection: React.FC<CTASectionProps> = ({ title, subtitle, buttons, padding }) => {
    return (
        <StyledSection $padding={padding}>
            {(title || subtitle) && (<TextContainer>
                {title && <StyledHeading dangerouslySetInnerHTML={{ __html: title }}></StyledHeading>}
                {subtitle && <StyledHighlight $style="normal">{subtitle}</StyledHighlight>}
            </TextContainer>)}
            <StyledContainer $flex="row">
                {buttons?.map(button => {
                    return (
                        <StyledButton href={button.href} style={button.variant} target="_blank">
                            {button.title}
                        </StyledButton>
                    );
                })}
            </StyledContainer>
        </StyledSection>
    );
};

export default CTASection;